import React from 'react'
import Heading from 'components/Luxkit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import TextButton from 'components/Luxkit/Button/TextButton'
import LargeContentToggle from 'components/Common/LargeContentToggle'
import ContentfulCard from './ContentfulCard'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'

const CarouselContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

const GridContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(1, 1fr);
    grid-gap: ${rem(16)};
`

function ContentfulCardCarousel({ title, cardItems, viewAllLink, isLargeContentWrapper, subtitle }: Omit<App.DiscoverDestinationPageCardCarousel, 'contentTypeId'>) {
  const CardItems = cardItems.map((props, idx) => <div key={`${props.title}-${idx}`}><ContentfulCard {...props} /></div>)
  return (
    <CarouselContainer>
      <VerticalSpacer gap={32}>
        <Group direction="horizontal" horizontalAlign="space-between">
          <Heading variant="heading2" dangerouslySetInnerHTML={{ __html: title }}></Heading>
          {viewAllLink && <TextButton href={viewAllLink} kind="tertiary" size="medium" shape="square">View all</TextButton>}
        </Group>
        <VerticalSpacer gap={2}>
          {subtitle && <BodyText variant="large">{subtitle}</BodyText>}
          {isLargeContentWrapper && <LargeContentToggle maxHeight={350} showMoreText="Read more" showLessText="Read less">
            <CSSBreakpoint min="desktop">
              <GridContainer>
                {CardItems}
              </GridContainer>
            </CSSBreakpoint>
            <CSSBreakpoint max="tablet">
              <CardCarousel pageSize={6}>
                {CardItems}
              </CardCarousel>
            </CSSBreakpoint>
          </LargeContentToggle>}
          {!isLargeContentWrapper && <>
            <CSSBreakpoint min="desktop">
              <GridContainer>
                {CardItems}
              </GridContainer>
            </CSSBreakpoint>
            <CSSBreakpoint max="tablet">
              <CardCarousel pageSize={6}>
                {CardItems}
              </CardCarousel>
            </CSSBreakpoint>
          </>}
        </VerticalSpacer>
      </VerticalSpacer>
    </CarouselContainer>
  )
}

export default ContentfulCardCarousel
